import { API } from './config';

// Real calls only: when the server cannot be reached the pages show an error with a Retry button.
export async function getJobs() {
  const res = await fetch(`${API}/jobs?status=Active`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
